import { DefaultDropdownProps, useInputHelper } from 'framework/form';
import { BudgetSearchFilterProps, useBudgetService } from '../index';
import BudgetDropdown from './BudgetDropdown';

interface AvailableBudgetsDropdownProps extends DefaultDropdownProps {
  budgetFromSource: string;
  filter?: BudgetSearchFilterProps;
  deps?: any[];
}

const AvailableBudgetsDropdown = ({ budgetFromSource, filter = {}, ...props }: AvailableBudgetsDropdownProps) => {
  const { getValue: getBudgetFromId } = useInputHelper({ source: budgetFromSource });
  const budgetFromId = getBudgetFromId() as string;
  const { searchAvailable, getSearchFilter } = useBudgetService();

  const loadAvailableBudget = async () => {
    if (!budgetFromId) {
      return {
        result: [],
      };
    }

    return searchAvailable(budgetFromId, { filter: getSearchFilter(filter) });
  };

  return <BudgetDropdown {...props} disabled={!budgetFromId} loadDataMethod={loadAvailableBudget} showLoader />;
};

export default AvailableBudgetsDropdown;
